import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { CARRIER } from '../../constants';
import { Dropdown } from '@zocdoc-frontend-common/components-dropdown';
import InsurancePropTypes from '../../InsurancePropTypes';

class BaseInsuranceCarrierDropdownView extends Component {
    static propTypes = {
        carrierId: PropTypes.string,
        carriers: PropTypes.array.isRequired,
        fetchCarriersIfNeeded: PropTypes.func.isRequired,
        imPayingMyselfText: PropTypes.string.isRequired,
        insuranceType: InsurancePropTypes.insuranceType.isRequired,
        isLoading: PropTypes.bool.isRequired,
        onChange: PropTypes.func.isRequired,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        onClick: noop,
    };

    componentDidMount() {
        this.props.fetchCarriersIfNeeded(this.props.insuranceType);
    }

    componentDidUpdate(prevProps) {
        if (this.props.insuranceType !== prevProps.insuranceType) {
            this.props.fetchCarriersIfNeeded(this.props.insuranceType);
        }
    }

    render() {
        const {
            carrierId,
            carriers,
            imPayingMyselfText,
            isLoading,
        } = this.props;

        if (isLoading) {
            return (
                <Dropdown
                    disabled
                    options={carriers}
                    placeholder="Loading..."
                />
            );
        }

        const options = [
            {
                id: CARRIER.IM_PAYING_MYSELF,
                name: imPayingMyselfText,
            },
            ...carriers,
        ];

        return (
            <Dropdown
                data-test="carriers-dropdown"
                data-uem-id="carriers-dropdown"
                onChange={this.handleChange}
                onClick={this.handleClick}
                options={options}
                selected={carrierId}
            />
        );
    }

    handleChange = e => this.props.onChange(e.target.value);
    handleClick = e => this.props.onClick(e.target.value);
}

export const InsuranceCarrierDropdownView = BaseInsuranceCarrierDropdownView;
